import { useState } from 'react'

const FAQS = [
  {
    q: 'What is an online pooja booking and is it authentic?',
    a: 'Your booking is a real seva performed physically at the listed temple by its own priests. Pandit Ji takes sankalp with your name and gotra before the ritual, and you receive the complete video as proof — nothing is symbolic or pre-recorded.',
  },
  {
    q: 'How do I receive proof that my pooja was performed?',
    a: 'The full recording of the sankalp (where your name is recited) and the pooja is delivered to your WhatsApp number within 24 hours of completion, along with photos of the offerings made in your name.',
  },
  {
    q: 'What if I do not know my gotra?',
    a: 'As per shastra, devotees who do not know their gotra may take sankalp under "Kashyap" gotra. Leave the field with that value and the priests will conduct the sankalp correctly.',
  },
  {
    q: 'When will I receive the prasad?',
    a: 'On Family and Joint Family packages, temple prasad along with an energized raksha sutra is couriered within 2–3 days of the pooja and typically reaches you in 5–7 working days anywhere in India.',
  },
  {
    q: 'Can I cancel my booking and get a refund?',
    a: 'Yes — you may cancel any time before the sankalp is taken for a full refund to the original payment method. Once the sankalp has been recited in your name, the seva is considered offered and cannot be cancelled.',
  },
  {
    q: 'Is my personal information safe?',
    a: 'Devotee names, gotra and birth details are shared only with the temple priest for the sankalp and are never used for anything else. Payments are processed through our secure, verified gateway.',
  },
]

/** Booking-specific FAQ accordion for the pooja storefront. */
export default function PoojaFaqSection() {
  const [open, setOpen] = useState(0)

  return (
    <section className="py-20 md:py-24 md:px-10 bg-background">
      <div className="container mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          {/* Sticky intro */}
          <div className="lg:col-span-4 lg:sticky lg:top-28 space-y-4">
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-secondary/50"></span>
              <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Seeker Queries</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl uppercase leading-tight text-primary">
              Booking <span className="text-gradient-gold font-bold block">Questions</span>
            </h2>
            <p className="text-xs md:text-sm leading-relaxed text-gray-500">
              Everything devotees ask before their first temple seva booking — sankalp, proof,
              prasad and refunds.
            </p>
          </div>

          {/* Accordion */}
          <div className="lg:col-span-8 space-y-3">
            {FAQS.map((f, i) => {
              const isOpen = open === i
              return (
                <div
                  key={f.q}
                  className={`rounded-2xl border transition-all duration-300 ${
                    isOpen ? 'bg-white border-secondary/40 shadow-md' : 'bg-white border-gray-200 hover:border-secondary/30'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="font-heading text-sm md:text-base text-primary uppercase leading-snug">{f.q}</span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all ${
                      isOpen ? 'bg-secondary text-white border-secondary rotate-45' : 'border-gray-200 text-primary/40'
                    }`}>
                      <i className="fa-solid fa-plus text-xs"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-6 pb-6 -mt-1 text-sm leading-relaxed text-gray-500">{f.a}</p>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
